/* Relocate the original app embed, never clone its trigger or alter its gates.
   The CC app binds to that trigger and mounts its dialog directly on body. */
class MonolytWithdrawalFooter extends HTMLElement {
  connectedCallback() {
    const attach = () => {
      const embed = document.getElementById('cc-widerruf-embed');
      if (!embed) return false;
      this.embed = embed;
      if (embed.parentElement !== this) this.append(embed);
      this.observer?.disconnect();
      return true;
    };

    if (!attach()) {
      this.observer = new MutationObserver(attach);
      this.observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    // Preserve the initialized app and its listeners during editor section reloads.
    if (this.embed?.parentElement === this) document.body.append(this.embed);
    this.embed = null;
  }
}

if (!customElements.get('monolyt-withdrawal-footer')) {
  customElements.define('monolyt-withdrawal-footer', MonolytWithdrawalFooter);
}
